import React from 'react';
import OnBoardingSections from '../../components/ptgc/onboarding/Index';  // ✅ Fix import

const OnBoardingPage = () => {
  return (
    <>
      <OnBoardingSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default OnBoardingPage;